import React from "react";

export const LegalFooter: React.FC = () => (
  <div>
    <p className="text-center text-sm text-gray-500 leading-relaxed">
      We follow GDPR and SOC 2 aligned privacy, security, and data protection practices across all operational workflows and services.
    </p>
    <p className="mt-2 text-center text-xs text-gray-500">
      © 2026 Wend AI · All rights reserved
    </p>
  </div>
);
